var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('Card',{attrs:{"title":`Tambah Komisi Dokter Untuk ${_vm.data.name}`},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('Form',{attrs:{"form":_vm.form,"doctors_id":_vm.doctors_id,"redirect":"/doctors/list"}})]},proxy:true}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }